export class ValidationTypeFilter {
    public IncludeInactive?: boolean;
}

export default ValidationTypeFilter;